export default __webpack_public_path__ + "static/media/nono.56fe9fb4.png";